import React, { Component } from 'react'
import './intro.css'

class Intro extends Component {

    render() {
        return (
            <div className="intro">
                <h1>React Curve </h1> 
                <p>Build UI not Pages, Start s-m-a-l-l to create something BIG</p>
            </div>
        )
    }
}

export default Intro 